import lineMultiLine from "assets/images/chart-images/multi-line.png";
import table  from "assets/images/chart-images/table.png";
const revTypeByTimePeriod = [
        {id: "ACCTPRT-L01r", name: "line", chartImage: lineMultiLine, disabled: false},
        {id: "ACCTPRT-T01r", name: "table", chartImage: table, v2: "Column", disabled: false},
        {id: "ACCTPRT-T02r", name: "table", chartImage: table, v2: "Row", disabled: false},
];

export default revTypeByTimePeriod;